import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ProgressBar from './ProgressBar';

function Confirmation() {
    const bookingData = JSON.parse(sessionStorage.getItem('confirmedBookingData')) || {};
    const {
        adults, children, childAges, rooms, checkInDate, checkOutDate,
        calculatedPrice, specialRequests, arrivalTime,
        firstName, surname, email, phone, address, city, country, zip
    } = bookingData;

    if (Object.keys(bookingData).length === 0) {
        return <div>No booking details provided.</div>;
    }

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = () => {
        const input = document.getElementById('printableArea');

        html2canvas(input, { scale: 2 }) // Increase scale for better resolution
            .then((canvas) => {
                const pdf = new jsPDF('p', 'mm', 'a4');
                const width = pdf.internal.pageSize.getWidth();
                const height = pdf.internal.pageSize.getHeight();

                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;

                const widthRatio = width / canvasWidth;
                const heightRatio = height / canvasHeight;
                const scale = Math.min(widthRatio, heightRatio);

                const adjustedWidth = canvasWidth * scale;
                const adjustedHeight = canvasHeight * scale;

                const xPosition = (width - adjustedWidth) / 2;
                const yPosition = (height - adjustedHeight) / 2;

                pdf.addImage(canvas.toDataURL('image/png'), 'PNG', xPosition, yPosition, adjustedWidth, adjustedHeight);
                pdf.save("invoice.pdf");
            })
            .catch((error) => {
                console.error("Error generating PDF:", error);
                alert("An error occurred while generating the PDF. Please try again.");
            });
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };

    const handleSendBooking = () => {
        const message = encodeURIComponent(`
            Booking Details:

            Name: ${firstName} ${surname}
            Email: ${email}
            Phone: ${phone}
            Address: ${address}, ${city}, ${country} - ${zip}
            Check In: ${formatDate(checkInDate)}
            Check Out: ${formatDate(checkOutDate)}
            Guests: ${adults} Adults, ${children} Children (${childAges?.map((age, index) => `${age} years old${index < childAges.length - 1 ? ', ' : ''}`).join('')})
            Total Price: $${calculatedPrice ? calculatedPrice.toFixed(2) : 'N/A'}
            Number of Rooms: ${rooms}
            Special Requests: ${specialRequests || "None"}
            Arrival Time: ${arrivalTime}
        `);

        const whatsappURL = `https://wa.me/+94769072745?text=${message}`;
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className="container mt-4">
            {/* ProgressBar added here */}
            <ProgressBar currentStep={4} totalSteps={4} />

            <div className="card p-4 shadow">
                <h2 className="text-center mb-4">Booking Confirmation</h2>
                <div id="printableArea">
                    <div className="checkout-details text-center">
                        <h4 className="mb-3">Booking Summary</h4>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Name:</strong></div>
                            <div className="col-6 col-md-8">{firstName} {surname}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Email:</strong></div>
                            <div className="col-6 col-md-8">{email}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Phone:</strong></div>
                            <div className="col-6 col-md-8">{phone}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Address:</strong></div>
                            <div className="col-6 col-md-8">{address}, {city}, {country} - {zip}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Check In:</strong></div>
                            <div className="col-6 col-md-8">{formatDate(checkInDate)}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Check Out:</strong></div>
                            <div className="col-6 col-md-8">{formatDate(checkOutDate)}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Guests:</strong></div>
                            <div className="col-6 col-md-8">{adults} Adults, {children} Children ({childAges?.map((age, index) => <span key={index}>{age} years old{index < childAges.length - 1 ? ', ' : ''}</span>)})</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Total Price:</strong></div>
                            <div className="col-6 col-md-8">${calculatedPrice ? calculatedPrice.toFixed(2) : 'N/A'}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Number of Rooms:</strong></div>
                            <div className="col-6 col-md-8">{rooms}</div>
                        </div>
                        {specialRequests && <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Special Requests:</strong></div>
                            <div className="col-6 col-md-8">{specialRequests}</div>
                        </div>}
                        {arrivalTime && <div className="row mb-2">
                            <div className="col-6 col-md-4"><strong>Arrival Time:</strong></div>
                            <div className="col-6 col-md-8">{arrivalTime}</div>
                        </div>}
                    </div>
                    <div className="text-center mt-3">
                        <p>Thank you for your booking!</p>
                    </div>
                </div>
                <div className="mt-4 d-flex justify-content-center flex-wrap">
                    <button className="btn btn-primary m-2" onClick={handlePrint}>Print Invoice</button>
                    <button className="btn btn-secondary m-2" onClick={handleDownload}>Download Invoice</button>
                    <button className="btn btn-success m-2" onClick={handleSendBooking}>Send Booking</button>
                </div>
            </div>
        </div>
    );
}

export default Confirmation;